module.exports = __webpack_public_path__ + "static/media/wav.e68f6b81.png";